import { render, staticRenderFns } from "./NavigationBar.vue?vue&type=template&id=5f794748&scoped=true&"
import script from "./NavigationBar.vue?vue&type=script&lang=js&"
export * from "./NavigationBar.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBar.vue?vue&type=style&index=0&id=5f794748&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f794748",
  null
  
)

export default component.exports